import css from './listPanel.module.scss';

import { get } from 'lodash';
import { memo, ReactNode } from 'react';

import Actions from './Actions';
import ContainerInfo from './ContainerInfo';
import ExeStatuses from './ExeStatuses';
import Resources from './Resources';
import { TAction, TContainerInfo } from './interface';

type Props = {
  index?: number;
  body: ReactNode | TContainerInfo;
  imageResources?: string[];
  exeStatuses?: Array<{
    label: string;
    lastProbeAt?: string;
    nextProbeAt?: string;
  }>;
  actions: TAction[][];
  actionsWidth?: string;
};

export default memo(function ListPanel({
  index,
  body,
  exeStatuses,
  imageResources,
  actions,
  actionsWidth,
}: Props) {
  return (
    <div className={css.root}>
      {index != null && <div className={css.index}>{index}</div>}
      <div className={css.left}>
        {get(body, 'type') === 'containerPanel' ? (
          <ContainerInfo info={body as TContainerInfo} />
        ) : (
          (body as ReactNode)
        )}
      </div>
      {imageResources && imageResources.length > 0 && (
        <Resources resourceUids={imageResources} />
      )}
      {exeStatuses && (
        <ExeStatuses className={css.exeStatuses} statuses={exeStatuses} />
      )}
      <Actions actions={actions} width={actionsWidth} />
    </div>
  );
});
